import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Card } from 'ui/cardV2';
import type { CardProps } from 'ui/cardV2/types';
import { colors, subtleShadow } from 'ui/theme';
import { MIN_DASHBOARD_CARD_HEIGHT } from 'modules/missionControl/constants';

type ModuleProps = PropsWithChildren<CardProps & { minHeight?: string }>;

const StyledCard = styled(Card)<{ $minHeight?: string } & CardProps>`
  && {
    background: rgba(255, 255, 255, 0.75);
    border: 2px solid ${colors.borderOnColor};
    ${({ $minHeight }) => $minHeight && `min-height: ${$minHeight};`}
    ${subtleShadow};
  }
`;

export const HOME_PAGE_TOOLBAR_TEST_ID = 'homepage-module';

export const Module: FC<PropsWithChildren<ModuleProps>> = ({
  children,
  minHeight = MIN_DASHBOARD_CARD_HEIGHT,
  ...props
}) => {
  return (
    <StyledCard
      data-test={HOME_PAGE_TOOLBAR_TEST_ID}
      $minHeight={minHeight}
      borderRadius="xxl"
      size="medium"
      {...props}
    >
      {children}
    </StyledCard>
  );
};
